import React from 'react';
import './PhasePage.css';
import FeatureSection from './FeatureSection';
import StayConnected from '../../components/StayConnected/StayConnected';

const PhasePage: React.FC = () => {
  return (
    <div className="phase-page">
      <div className="phase-banner">
        <div className="scrolling-container">
          <div className="scrolling-text">
            {"Phase Fitness • ".repeat(5)}
          </div>
          <div className="scrolling-text">
            {"Phase Fitness • ".repeat(5)}
          </div>
        </div>
      </div>

      <div className="phase-content">
        <h1 className="phase-main-title impact">
          <span className="orange-text">"</span>
          Phase Fitness
          <span className="orange-text">"</span>
        </h1>
        <p className="phase-subtitle">Your AI-powered fitness companion. Transform your workout journey with personalized coaching, smart nutrition tracking, and adaptive plans that evolve with your goals.</p>

        <FeatureSection />
      </div>
      <StayConnected />
    </div>
  );
};

export default PhasePage; 